<template>
    <div
        class="item tw-flex tw-items-center hover:tw-bg-gray-0 tw-cursor-pointer tw-relative"
        :class="[{ 'tw-bg-gray-0': active || newParticipant }]"
        @click="onItemClick"
        v-if="thread || showOnlyThread || newParticipant"
    >
        <div class="tw-mr-4">
            <thread-avatar :participants="participants" :showIndicator="false"></thread-avatar>
        </div>
        <div>
            <div class="name">
                <thread-name :participants="participants" :bold="!mine && unread" :size="'lg'"></thread-name>
            </div>
            <template v-if="!newParticipant">
                <template v-if="deletedMessage">
                    <p class="qs-400 tw-gray-500 tw-italic tw-text-sm">{{ translations['messages.deleted'] }}</p>
                </template>
                <div class="tw-flex tw-items-center" v-else>
                    <span v-if="truncatedMessage" :class="['tw-text-base tw-block', {'tw-font-bold' : !mine && unread}]">
                        <i v-if="mine" :class="['fal tw-text-blue-600 tw-mr-2', sentMessageRead ? 'fa-check-double' : 'fa-check']"></i>{{ truncatedMessage }}
                    </span>
                </div>
            </template>
            <p v-if="!newParticipant" class="tw-text-gray-600 time" v-text="lastActivityReadable"></p>
            <div class="tw-text-gray-600 tw-w-5 tw-h-4 tw-absolute tw-top-2 tw-right-3" @click.stop="toggleMenu">
                <i class="far fa-ellipsis-h"></i>
            </div>
        </div>
        <div v-if="showMenu" class="tw-bg-white tw-py-3 tw-rounded tw-shadow tw-absolute tw-top-4 tw-right-0 tw-z-20">
            <dropdown-menu :forceAlign="'left'" @close="showMenu = false">
                <dropdown-menu-item @click.native="handleViewProfileClick">
                    {{ translations['messages.view_profile'] }}
                </dropdown-menu-item>
                <dropdown-menu-item @click.native="handleDeleteChatClick">
                    {{ translations['messages.delete_chat'] }}
                </dropdown-menu-item>
            </dropdown-menu>
            <!-- <ul>
                <li class="hover:tw-bg-gray-100 tw-px-7 tw-py-4 tw-text-lg"><i class="far fa-user-alt"></i><a :href="profileUrl" class="tw-font-semibold tw-inline-block tw-ml-3">Profiel bekijken</a></li>
                <li class="hover:tw-bg-gray-100 tw-px-7 tw-py-4 tw-text-lg" @click="deleteThread"><i class="far fa-trash-alt"></i><span class="tw-font-semibold  tw-inline-block tw-ml-3">Chat verwijderen</span></li>
            </ul> -->
        </div>
    </div>
</template>

<script>
import ThreadAvatar from './ThreadAvatar';
import ThreadName from './ThreadName';
import Global from '../../mixins/Global.js';


export default {
    name: 'ThreadItem',

    props: {
        threadId: [String, Number, undefined], // can be undefined if we get userId as prop
        activeThread: [String, Number],
        newParticipant: [Array, null],
        showOnly: {
            type: Boolean,
            default: false
        },
        userId: {
            type: [String, Number],
            default: undefined
        },
    },

    mixins: [Global],

    data() {
        return {
            showMenu: false,
            showOnlyThread: null,
            id: null,
        };
    },

    components: {
        'thread-avatar': ThreadAvatar,
        'thread-name': ThreadName,
    },

    watch: {
        active(newValue) {
            if (newValue === false) {
                this.showMenu = false;
            }
        }
    },

    computed: {
        sortedMessages() {
            let messages;

            if(this.thread && this.thread.messages.length > 0) {
                messages = this.thread.messages.filter(element => {
                    return element !== null;
                });
			} else if(this.showOnlyThread && this.showOnlyThread.messages.length > 0) {
                messages = this.showOnlyThread.messages.filter(element => {
                    return element !== null;
                });
			}

            if(messages.length > 0) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				return messages.sort((a, b) => a.created_at > b.created_at ? -1 : 1);
            } else {
				return [];
			}
        },

        deletedMessage() {
            if (this.thread && this.sortedMessages.length > 0) {
                const lastMessage = [...this.sortedMessages].sort((a,b) => {
                    return a.created_at - b.created_at;
                })[0];

                if (lastMessage && lastMessage.deleted_at) {
                    return true;
                }
            }

            return false;
        },

        lastActivityReadable() {
            const lastActivity = this.thread ? this.thread.last_activity : this.showOnlyThread.last_activity;
			// .replace is used to have a valid date in safari
            const d = new Date(lastActivity.replace(/-/g, "/"));

            moment.locale(this.settings['locale']);

            if (moment(d).isSame(new Date(), 'day')) {
                const m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
                return d.getHours() + ':' + m;
            }

            return moment(d).format('D MMM');
        },

        active() {
            return this.activeThread === this.id;
        },

        participants() {
            return this.thread != null && !this.newParticipant ? this.thread.partners.filter((partner) => {
                return partner.id !== user.id;
            }) : this.newParticipant ? this.newParticipant : [];
        },

        profileUrl() {
            return '/profile/' + this.participants[0].username;
        },

        me() {
            return this.thread.partners.filter((partner) => {
                return partner.id === user.id;
            })[0];
        },

        mine() {
            if (this.newParticipant) {
                return false;
            }
            if(this.lastSendMessage) {
                return this.lastSendMessage.user_id === user.id;
            }
            return false;
        },

        sentMessageRead() {
            if (this.newParticipant) {
                return false;
            }
            const message = this.lastSendMessage;
            const _participants = this.participants;
            let read = false;

            _participants.forEach(element => {
                if (new Date(element.last_read) > new Date(message.created_at)) {
                    read = true;
                }
            });

            return read;
        },

        unread() {
            if (this.newParticipant) {
                return false;
            }

            const { last_activity } = this.thread ? this.thread : this.showOnlyThread;
            const { last_read } = this.me;

            if (this.active) {
                return false;
            }

            if (new Date(last_activity) > new Date(last_read)) {
                return true;
            }

            return false;
        },

        truncatedMessage() {
			let body;

            if(this.sortedMessages.length > 0) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				body = this.sortedMessages[0].body;
            } else {
				return '';
			}

            if (body.includes('media.tenor')) {
                return 'GIF';
            }

            // strip html tags from the body
            let regex = /(<([^>]+)>)/ig;
            body = body.replace(regex, ' ');

            // return truncated text when message is longer than 30 char, else return complete text
            return body.length > 30 ? body.slice(0, 30) + '...' : body;
        },

        thread() {
            if (this.id) {
                return Thread.find(this.id);
            }
            return null;
        },

        lastSendMessage() {
            let latestMessage = null;

            this.thread.messages.forEach((item, i) => {
                if(item === null) {
                    return;
                }
                if (i === 0 || item.created_at > latestMessage.created_at) {
                    latestMessage = item;
                }
            });

            return latestMessage;
        },
    },

    methods: {
        handleViewProfileClick() {
            this.showMenu = false;
            this.goToProfile();
        },

        handleDeleteChatClick() {
            this.showMenu = false;
            this.deleteThread();
        },

        async getThreadId() {
            if (this.threadId !== undefined) {
                this.id = this.threadId;
            } else {
                const response = await Thread.api().getThreadByUserId(this.userId);
                const foundThread = response.response.data.data;
                if (foundThread.id) {
                    this.id = foundThread.id;
                }
            }
        },

        fetchThread(id) {
            Thread.api()
                .fetchById(id);
        },

        fetchAndShowThread(id) {
            // when there is a deleted thread in search result,
            // we need to display it without all of the found items being saved to the store
            const url = `/api/v3/inbox/${this.$threadId}`;
            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    this.showOnlyThread = data.data;
                });
        },

        deleteThread() {
            this.$emit('delete-thread');
        },

        onItemClick() {
            // don't trigger update when the threadId is a fake id
            if (Number.isInteger(this.threadId)) {
                Thread.api().updateLastActivity(this.threadId, user.id);
            }

            let id;
            if (this.thread) {
                id = this.thread.id;
            } else {
                id = this.showOnlyThread.id;
            }
            this.showMenu = false;
            this.$emit('item-click', id);
        },

        goToProfile() {
            window.open(this.profileUrl, '_blank');
        },

        toggleMenu() {
            this.showMenu = !this.showMenu;
        }
    },

    mounted() {
        this.getThreadId();
    }
};
</script>

<style lang="scss" scoped>
    .item {
        padding: 17px;
        margin: 16px;
        border-radius: 10px;

        &:first-of-type {
            margin-top: 10px;
        }

        &:active {
            @apply tw-bg-gray-100;
        }
    }

    .name {
        margin-bottom: 2px;
    }

    .time {
        font-size: 11px;
    }
</style>
